var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign-out_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 129.98,
    y1: 215.51,
    x2: 370.75,
    y2: 215.51,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign-out_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 135.98,
    y1: 215.51,
    x2: 364.75,
    y2: 215.51,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "sign-out_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 8.324219 28.875 C 6.148438 28.875 4.382812 27.101562 4.382812 24.929688 L 4.382812 7.058594 C 4.382812 6.007812 4.792969 5.015625 5.539062 4.273438 C 6.28125 3.527344 7.269531 3.121094 8.320312 3.121094 L 11.65625 3.125 C 12.191406 3.125 12.621094 3.558594 12.621094 4.09375 C 12.621094 4.625 12.1875 5.058594 11.65625 5.058594 L 8.324219 5.054688 C 7.785156 5.054688 7.285156 5.261719 6.90625 5.640625 C 6.527344 6.019531 6.316406 6.523438 6.316406 7.058594 L 6.316406 24.929688 C 6.316406 26.039062 7.21875 26.941406 8.328125 26.941406 L 11.53125 26.945312 C 11.789062 26.945312 12.03125 27.046875 12.214844 27.230469 C 12.398438 27.414062 12.496094 27.65625 12.496094 27.914062 C 12.496094 28.449219 12.0625 28.882812 11.53125 28.882812 Z M 8.324219 28.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 11.527344 28.433594 L 8.324219 28.429688 C 6.398438 28.429688 4.828125 26.855469 4.828125 24.929688 L 4.828125 7.058594 C 4.828125 6.125 5.191406 5.246094 5.855469 4.585938 C 6.515625 3.929688 7.390625 3.566406 8.320312 3.566406 L 8.328125 3.566406 L 11.65625 3.570312 C 11.945312 3.570312 12.175781 3.804688 12.175781 4.09375 C 12.175781 4.378906 11.941406 4.613281 11.65625 4.613281 L 11.652344 4.613281 L 8.324219 4.605469 L 8.320312 4.605469 C 7.667969 4.605469 7.050781 4.863281 6.589844 5.324219 C 6.125 5.785156 5.871094 6.402344 5.871094 7.058594 L 5.871094 24.929688 C 5.871094 26.28125 6.972656 27.386719 8.328125 27.386719 L 11.53125 27.390625 C 11.820312 27.390625 12.050781 27.625 12.050781 27.914062 C 12.050781 28.199219 11.816406 28.433594 11.53125 28.433594 Z M 11.527344 28.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#sign-out_svg__linear0)"
    },
    d: "M 22.480469 21.132812 C 22.230469 21.132812 21.996094 21.035156 21.816406 20.859375 C 21.640625 20.679688 21.542969 20.445312 21.542969 20.195312 C 21.542969 19.945312 21.640625 19.707031 21.816406 19.53125 L 24.382812 16.964844 L 10.613281 16.964844 C 10.09375 16.964844 9.671875 16.542969 9.671875 16.027344 C 9.671875 15.507812 10.09375 15.085938 10.613281 15.085938 L 24.386719 15.085938 L 21.84375 12.546875 C 21.476562 12.179688 21.476562 11.582031 21.84375 11.21875 C 22.019531 11.039062 22.257812 10.941406 22.507812 10.941406 C 22.757812 10.941406 22.992188 11.039062 23.171875 11.21875 L 27.3125 15.359375 C 27.492188 15.539062 27.589844 15.773438 27.589844 16.023438 C 27.589844 16.273438 27.492188 16.511719 27.3125 16.6875 L 23.144531 20.855469 C 22.96875 21.035156 22.730469 21.132812 22.480469 21.132812 Z M 22.480469 21.132812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#sign-out_svg__linear1)"
    },
    d: "M 22.480469 20.6875 C 22.355469 20.6875 22.230469 20.636719 22.132812 20.542969 C 21.941406 20.351562 21.941406 20.039062 22.132812 19.847656 L 25.460938 16.519531 L 10.613281 16.519531 C 10.339844 16.519531 10.121094 16.300781 10.121094 16.027344 C 10.121094 15.753906 10.339844 15.535156 10.613281 15.535156 L 25.464844 15.535156 L 22.160156 12.230469 C 21.96875 12.039062 21.96875 11.726562 22.160156 11.535156 C 22.351562 11.339844 22.664062 11.339844 22.855469 11.535156 L 27 15.675781 C 27.089844 15.769531 27.144531 15.894531 27.144531 16.023438 C 27.144531 16.15625 27.089844 16.28125 27 16.371094 L 22.832031 20.542969 C 22.734375 20.636719 22.609375 20.6875 22.480469 20.6875 Z M 22.480469 20.6875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.c46fadd28a3f91b9c644c20376ac8c6f.svg";
export { ForwardRef as ReactComponent };